import React from "react";
import { Routes, Route } from "react-router-dom";

import { websiteRoutes } from "./routes";
import WebsiteLayout from "./pages/layout/"

function App() {
  return (
    <React.Fragment>
      <Routes>

        {websiteRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <WebsiteLayout>
                {route.component}
              </WebsiteLayout>
            }
            key={idx}
            exact={true}
          />
        ))}

        {/* {popupRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <>{route.component}</>}
            key={idx}
            exact={true}
          />
        ))} */}

      </Routes>
    </React.Fragment>
  );
}

export default App;
